var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.computedMetaFields),function(item){return _c('div',{key:item.name,staticClass:"card__meta-field"},[_vm._v(_vm._s(item.label)+": "+_vm._s(item.value))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }